import { CarInsuranceQuote } from '@hyphengroup/cms-components/components/ProductCard/SectionPremiumCI';
import { PremiumStatus } from '@hyphengroup/cms-components/types/car-insurance';
import { CarInsuranceContextState } from 'car-insurance/context';
import { fetchCarInsuranceDataMM } from './utils';

export async function getMoneymaxQuotes(
  props: CarInsuranceContextState,
): Promise<{
  status: PremiumStatus;
  quotes: Array<CarInsuranceQuote>;
}> {
  const {
    requestParams: {
      driver: { value: driverValue },
      prices: { value: pricesValue },
      vehicle: { value: vehicleValue },
    },
  } = props;

  if (!driverValue || !pricesValue) {
    return {
      status: 'fail',
      quotes: [],
    };
  }

  return fetchCarInsuranceDataMM({
    driver: driverValue,
    prices: pricesValue,
    vehicle: vehicleValue,
  })
    .then((responce) => {
      return {
        status: true,
        quotes: responce,
      };
    })
    .catch((err) => {
      console.error('Polling for car insurance failed:', err);
      return {
        status: 'fail',
        quotes: [],
      };
    });
}
